document.addEventListener("DOMContentLoaded", () => {
    const track = document.querySelector(".marquee-track");

    if (!track) return;

    const singleSetWidth = track.scrollWidth / 2;
    const pixelsPerSecond = 80;

    track.style.animationDuration = `${singleSetWidth / pixelsPerSecond}s`;
});


// custom popup script start
document.addEventListener("DOMContentLoaded", () => {
  const popup = document.getElementById("custom-popup");
  if (!popup) return;

  const delay = Number(popup.dataset.delay) * 1000;
  const showOnce = popup.dataset.showOnce === "true";

  const storageKey = "shopify-popup-shown";

  if (showOnce && localStorage.getItem(storageKey)) {
    return;
  }

  setTimeout(() => {
    popup.hidden = false;

    if (showOnce) {
      localStorage.setItem(storageKey, "true");
    }
  }, delay);

  popup.querySelector(".custom-popup__close")?.addEventListener("click", () => {
    popup.hidden = true;
  });

  popup.querySelector(".custom-popup__overlay")?.addEventListener("click", () => {
    popup.hidden = true;
  });
});

// custom popup script end

$(function () {

    if ($('.hm-banner-slider').length) {
        $('.hm-banner-slider').owlCarousel({
            items: 1,
            loop: true,
            dots: true,
            autoplay: true,
            autoplayTimeout: 10000,
            autoplayHoverPause: true,
            smartSpeed: 800
        });
    }

    if ($('.testimonial-carousel').length) {
        $('.testimonial-carousel').owlCarousel({
            loop: true,
            margin: 30,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 3500,
            autoplayHoverPause: true,
            smartSpeed: 800,
            responsive: {
                0: {
                    items: 1,
                    nav: true
                },
                1000: {
                    items: 2
                }
            }
        });
    }

});

// mega menu slider script
  
  function initSlider() {

  let $slider = $('.mega-menu-slider');

  if (!$slider.length || !$.fn.owlCarousel) return;

  $slider.each(function () {

    let $this = $(this);

    // already initialized
    if ($this.hasClass('owl-loaded')) {
      return;
    }

    $this.owlCarousel({
      items: 2,
      loop: true,
      margin: 15,
      nav: true,
      dots: false
    });

  });
}


$(document).on('mouseenter', '.header-menu__inner .menu-list__link', function () {

  setTimeout(function () {
    initSlider();
  }, 100);

});

  document.querySelector('.back-to-top')?.addEventListener('click', function(e) {
  e.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });
});


$(document).ready(function(){

  var skincare_slider = $('.skincare-slider');

  skincare_slider.owlCarousel({
    loop:true,
    margin:30,
    nav:false,
    dots:false,
    smartSpeed:600,
    stagePadding:0,

    responsive:{
      0:{
        items:1.2
      },
      768:{
        items:2.2
      },
      1200:{
        items:3.6
      }
    },

    onInitialized:function(event){
      setActiveItem(event);
      updatePagination(event);
    },

    onTranslated:function(event){
      setActiveItem(event);
      updatePagination(event);
    }
  });

  $('.next-btn').click(function(){
    skincare_slider.trigger('next.owl.carousel');
  });

  $('.prev-btn').click(function(){
    skincare_slider.trigger('prev.owl.carousel');
  });

  // Active Large First Item
  function setActiveItem(event){

    $('.skincare-slider .owl-item').removeClass('active-large');

    var firstActive = $('.skincare-slider .owl-item.active').first();

    firstActive.addClass('active-large');
  }

  // Pagination
  function updatePagination(event){

    var carousel = event.relatedTarget;

    var current = carousel.relative(carousel.current()) + 1;

    var total = carousel.items().length;

    $('.current-slide').text(
      current.toString().padStart(2, '0')
    );

    $('.total-slide').text(
      total.toString().padStart(2, '0')
    );

    var progress = (current / total) * 100;

    $('.active-line').css('width', progress + '%');
  }


});


document.addEventListener('click', function(e) {
  const parentLink = e.target.closest('.parent-menu');

  if (!parentLink) return;

  const submenu = parentLink.parentElement.querySelector('.menu-drawer__menu--childlist');

  if (submenu) {
    e.preventDefault(); 

    submenu.classList.toggle('active');

    if (submenu.classList.contains('active')) {
      submenu.style.maxHeight = submenu.scrollHeight + 'px';
    } else {
      submenu.style.maxHeight = '0px';
    }
  }
});


// header sticky 

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');
  if (!header) return;

  const announcementBar = document.querySelector('.announcement-bar');
  const topMenu = document.querySelector('.header-top-menu');

  function updateOffset() {
    const announcementH = announcementBar?.offsetHeight || 0;
    const topMenuH = topMenu?.offsetHeight || 0;

    document.documentElement.style.setProperty(
      '--header-offset',
      `${announcementH + topMenuH}px`
    );
  }

  updateOffset();

  window.addEventListener('resize', updateOffset);

  window.addEventListener('scroll', () => {
    header.classList.toggle(
      'header-sticky',
      window.scrollY > 80
    );
  });
});